/* eslint-disable */
export enum EDashboardIconSize {
	SMALL = 'small',
	BIG = 'big',
}

export enum EDashboardIconType {
	PLACES = 'places',
	ACTIVITIES = 'activities',
	REVIEWS = 'reviews',
	PHOTOS = 'photos',
}

interface IDashboardIconOptions extends Partial<HTMLSpanElement> {
	size?: EDashboardIconSize;
	type: EDashboardIconType;
}

export function createDashboardIcon({
	className = "",
	size = EDashboardIconSize.BIG,
	type,
	...rest
}: IDashboardIconOptions): HTMLSpanElement {
	return Mapy.Util.node("span", {
		className: `ui-dashboard-icon ui-dashboard-icon--${size} ${className}`,
		innerHTML: `<img src="/img/userprofile/${type}-${size}.svg" />`,
		...rest,
	}) as HTMLSpanElement;
}
